import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [{
  path: '/',
  name: 'home',
  component: () => import('../views/home/home.vue')
},{
  path: '/schoolProfile',
  name: 'schoolProfile',
  component: () => import('../views/schoolProfile/schoolProfile.vue')
},{
  path: '/teachingFacilities',
  name: 'teachingFacilities',
  component: () => import('../views/schoolProfile/teachingFacilities.vue')
},{
  path: '/teachingFacilitiesdetails',
  name: 'teachingFacilitiesdetails',
  component: () => import('../views/schoolProfile/teachingFacilitiesdetails.vue')
},{
  path: '/honordetails',
  name: 'honordetails',
  component: () => import('../views/schoolProfile/honordetails.vue')
},{
  path: '/honor',
  name: 'honor',
  component: () => import('../views/schoolProfile/honor.vue')
},{
  path: '/teachingStaff',
  name: 'teachingStaff',
  component: () => import('../views/teachingStaff/teachingStaff.vue')
},
{
  path: '/teachingStaffDetails',
  name: 'teachingStaffDetails',
  component: () => import('../views/teachingStaff/teachingStaffDetails.vue')
},
{
  path: '/serviceItems',
  name: 'serviceItems',
  component: () => import('../views/serviceItems/serviceItems.vue')
},
{
  path: '/details',
  name: 'details',
  component: () => import('../views/serviceItems/details.vue')
},
{
  path: '/detailso',
  name: 'detailso',
  component: () => import('../views/serviceItems/detailso.vue')
},
{
  path: '/detailst',
  name: 'detailst',
  component: () => import('../views/serviceItems/detailst.vue')
},
{
  path: '/fireEquipment',
  name: 'fireEquipment',
  component: () => import('../views/serviceItems/fireEquipment.vue')
},
{
  path: '/maintenance',
  name: 'maintenance',
  component: () => import('../views/serviceItems/maintenance.vue')
}, 
{//
  path: '/offerACourse',
  name: 'offerACourse',
  component: () => import('../views/offerACourse/offerACourse.vue')
},{
  path: '/trainingLocation',
  name: 'trainingLocation',
  component: () => import('../views/offerACourse/trainingLocation.vue')
},{
  path: '/trainingProgram',
  name: 'trainingProgram',
  component: () => import('../views/offerACourse/trainingProgram.vue')
},{//11111
  path: '/offerACoursedetails',
  name: 'offerACoursedetails',
  component: () => import('../views/offerACourse/offerACoursedetails.vue')
},{
  path: '/trainingLocationdetailso',
  name: 'trainingLocationdetailso',
  component: () => import('../views/offerACourse/trainingLocationdetailso.vue')
},{
  path: '/trainingProgramdetails',
  name: 'trainingProgramdetails',
  component: () => import('../views/offerACourse/trainingProgramdetails.vue')
},{//
  path: '/newsInformation',
  name: 'newsInformation',
  component: () => import('../views/newsInformation/newsInformation.vue')
},{//
  path: '/newsInformationdetails',
  name: 'newsInformationdetails',
  component: () => import('../views/newsInformation/newsInformationdetails.vue')
},{//
  path: '/recruitments',
  name: 'recruitments',
  component: () => import('../views/recruitment/recruitments.vue')
},{//
  path: '/recruitmentsdetails',
  name: 'recruitmentsdetails',
  component: () => import('../views/recruitment/recruitmentsdetails.vue')
},{//
  path: '/contactUs',
  name: 'contactUs',
  component: () => import('../views/contactUs/contactUs.vue')
},]


const router = new VueRouter({
  routes
})
router.afterEach((to, from) => {
  // 在每次路由跳转后滚动到顶部
  window.scrollTo(0, 0);
});

export default router